import React from 'react';
import SalesPoster from '../sales-poster/sales-poster';
import type { BringAFriend as Props } from './bring-a-friend.types';

const BringAFriend: React.FC<Props> = props => <SalesPoster {...props} />;

export default BringAFriend;
